module.exports = __webpack_public_path__ + "static/media/7.Drip Fittings.34ebfff1.jpeg";